import type { FC } from "react";
import { Input } from "../../form";

export type MetricCurrencyInputProps = {
	testId: string;
	value: number | null;
	onChange: (value: number | null) => void;
	disabled?: boolean;
};

/**
 * Currency editor sized for a metric card's value row. The `$` sits over the field rather than in
 * `Input`'s prefix slot so the number stays flush with the display value it replaces.
 */
export const MetricCurrencyInput: FC<MetricCurrencyInputProps> = ({
	testId,
	value,
	onChange,
	disabled,
}) => (
	<div className="relative flex-1 min-w-0">
		<span className="absolute left-2 top-1/2 -translate-y-1/2 text-tertiary text-sm pointer-events-none z-10">
			$
		</span>
		<Input
			testId={testId}
			type="number"
			disabled={disabled}
			value={value ?? ""}
			onChange={(e) => {
				onChange(e.target.value === "" ? null : Number(e.target.value));
			}}
			containerClassName="h-[28px] flex-1 min-w-0"
			className="h-[28px] w-full bg-surface-light ml-5 text-sm py-0 pl-1 pr-1 rounded-md [&[type=number]]:appearance-textfield [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
		/>
	</div>
);
